export default "__VITE_ASSET__CFb4YP_4__"